import { doc, getDoc, getFirestore } from "firebase/firestore";
import { app } from "../lib/firebase"; // Changed manually
//const db = getFirestore(app); // Changed manually

interface UserProfile {
  email: string;
  photoURL: string;
  createdAt: Date;
  updatedAt: Date;
  displayName: string;
  userId: string;
  friends: string[];
  friendRequests: string[];
}

async function RetrieveUserProfileById(
  userID: string
): Promise<UserProfile | null> {
  const db = getFirestore(app);
  const q = doc(db, "userProfiles", userID);
  const docSnap = await getDoc(q);

  if (docSnap.exists()) {
    const data = docSnap.data();
    const userId = docSnap.id;
    return {
      email: data.email || "",
      photoURL: data.photoURL || "",
      createdAt: data.createdAt?.toDate() || new Date(),
      updatedAt: data.updatedAt?.toDate() || new Date(),
      displayName: data.displayName || "",
      userId,
      friends: data.friends || [],
      friendRequests: data.friendRequests || [],
    };
  }

  return null;
}

export default RetrieveUserProfileById;
